import ClipLoader from "react-spinners/ClipLoader";
import styled from "styled-components";
import { colors } from "../../styles/colors";

type Props = {
  color?: string;
  className?: string;
  size?: number;
};

export const LoadingSpinner = (props: Props) => {
  return (
    <Container className={props.className}>
      <ClipLoader
        color={props.color ?? colors.white}
        loading={true}
        size={props.size ?? 24}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 4px;
`;
